import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalActivityDay(props) {
  const activityDay = props.model;
  const { id } = props;

  return (
    <Modal
      title="Nuevo dia para excluir envio de archivo"
      model={activityDay}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="report/file-day-report"
      state
      dataForce={{
        file_report_id: id,
      }}
    >
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Dia de la semana</InputLabel>
        <Select
          required
          defaultValue={!!activityDay ? activityDay.code : ''}
          inputProps={{
            name: 'code',
          }}
        >
          <MenuItem value="00">Lunes</MenuItem>
          <MenuItem value="01">Martes</MenuItem>
          <MenuItem value="02">Miércoles</MenuItem>
          <MenuItem value="03">Jueves</MenuItem>
          <MenuItem value="04">Viernes</MenuItem>
          <MenuItem value="05">Sábado</MenuItem>
          <MenuItem value="06">Domingo</MenuItem>
        </Select>
      </FormControl>
    </Modal>
  );
}
